import { styled } from '@mui/material';
import { Typography, TableCell, TableHead } from '@mui/material';

export const StyledNote = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.darkBodyText,
  marginBottom: theme.spacing(6),
  width: '100%',
  fontSize: theme.fontSizes?.regular,
}));

export const StyledTableHead = styled(TableHead)(() => ({
  backgroundColor: 'rgba(234, 233, 232, .2)',
}));

export const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
  minWidth: 120,
  borderBottomColor: theme.palette?.borderColor?.lightGrey,
  lineHeight: '22px',
  fontSize: theme.fontSizes?.sm,
  fontWeight: 700,
  fontStyle: 'normal',
}));

export const StyledTableBodyCell = styled(TableCell)(({ theme }) => ({
  borderBottomColor: theme.palette?.borderColor?.lightGrey,
  color: theme.palette.text.darkBodyText,
  fontSize: theme.fontSizes?.regular,
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  marginTop: theme.spacing(1),
  fontSize: theme.fontSizes?.sm,
}));

export const WarningMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(1),
  fontSize: theme.fontSizes?.sm,
}));
